import edit from './edit'

import { destroy as destroyForm } from 'redux-form'

import CreatePage, { TRANSITION_DURATION } from 'components/pages/create'

import PoolBasics from 'components/pages/create/create_basics'
import Participants from 'components/pages/create/create_preferences'
import PoolDescription from 'components/pages/create/create_description'
import PoolCoverCreate from 'components/pages/create/create_cover'
import PoolPrepublish from 'components/pages/create/create_prepublish'
import PoolPublish from 'components/pages/create/create_publish'
import PoolShare from 'components/pages/create/create_share'
import CampaignPage from 'components/pages/campaign'
import CountryBlockedError from 'components/common/country_blocked'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'

import {
  NEW_CAMPAIGN_ID,
  create,
  resetRemoteOperation,
} from 'redux/modules/campaign'
import { getNewCampaignSelector } from 'redux/selectors/campaign'
import { mockForPreview } from 'redux/modules/txns'
import {
  getStepName,
  assertInitialStep,
  assignActionToRouterParams,
} from 'lib/route_utils'

const INITIAL_STEP = 'basics'

export default (store, history) => ({
  path: 'create',
  getComponent(nextState, callback) {
    if (store.getState().current_user.moneypools_blocked) {
      return callback(null, CountryBlockedError)
    }
    return callback(null, CreatePage)
  },
  onEnter(nextState, replace) {
    store.dispatch((d, getState) => {
      d(create()) // creates the new campaign object.
    })
    nextState.params.nextStep = getStepName('create', nextState.routes)
    if (nextState.params.nextStep !== 'share/:campaignId') {
      nextState.params.campaignId = NEW_CAMPAIGN_ID
      assertInitialStep('create', INITIAL_STEP, nextState, replace)
    }
  },
  onChange(prevState, nextState) {
    assignActionToRouterParams(nextState)
    nextState.params.campaignId = NEW_CAMPAIGN_ID
    nextState.params.prevStep = getStepName('create', prevState.routes)
    nextState.params.nextStep = getStepName('create', nextState.routes)
  },
  childRoutes: [
    {
      path: INITIAL_STEP,
      component: PoolBasics,
      onEnter(nextState) {
        if (
          nextState.location.action !== 'POP' ||
          !nextState.params.prevSteps
        ) {
          sendEnsightenEvent('MoneyPoolStart')
        }
      },
    },
    { path: 'preferences', component: Participants },
    { path: 'description', component: PoolDescription },
    { path: 'cover', component: PoolCoverCreate },
    {
      path: 'preview',
      component: CampaignPage,
      childRoutes: [edit(store, history)],
      onEnter(nextState) {
        if (nextState.location.action !== 'POP' || !nextState.params.prevStep) {
          store.dispatch((d, getState) => {
            const campaign = getNewCampaignSelector(getState())
            d(
              mockForPreview(
                campaign.share_progress,
                campaign.share_contributors,
                campaign.share_contributions
              )
            )

            // Destroy the form only once the transition has completed, so that the data in the form
            // doesn't disappear while transitioning.
            setTimeout(() => {
              d(destroyForm('create_basics'))
              d(destroyForm('create_preferences'))
              d(destroyForm('create_description'))
              d(destroyForm('create_cover'))
            }, TRANSITION_DURATION)
          })
        }
      },
    },
    { path: 'prepublish', component: PoolPrepublish },
    {
      path: 'publish',
      component: PoolPublish,
      onEnter(nextState) {
        if (nextState.location.action !== 'POP') {
          store.dispatch(resetRemoteOperation(NEW_CAMPAIGN_ID))
        }
      },
    },
    { path: 'share/:campaignId', component: PoolShare },
  ],
})
